import Api from '../Api';

import { url } from './config';
import { CrmType } from './types';

const api = new Api<CrmType>(url);

export default api;
